import { useEffect, useState } from "react";

import Loader from "common/components/Loader";
import usePaymentSources from "common/datahooks/usePaymentSources";
import type { PaymentSource } from "common/types";

import AddPaymentMethod from "./AddPaymentMethod";
import PaymentMethodSelection from "./PaymentMethodSelection";

export interface PaymentMethodProps {
  subscriptionId: string;
  paymentSource: PaymentSource;
  onBack: () => void;
  // Called when user picks an existing source (selection screen)
  onSelect?: (paymentSource: PaymentSource) => void;
  // Called when user adds a brand-new source (add screen)
  onNext?: (paymentSource: PaymentSource) => void;
}

export default function PaymentMethod({
  subscriptionId,
  paymentSource,
  onBack,
  onNext = undefined,
  onSelect = undefined,
}: PaymentMethodProps) {
  const { paymentSources, isLoadingPaymentSources } = usePaymentSources();
  const [isAddingPaymentMethod, setIsAddingPaymentMethod] = useState(false);

  useEffect(() => {
    if (!isLoadingPaymentSources && paymentSources) {
      setIsAddingPaymentMethod(!paymentSources.length);
    }
  }, [paymentSources, isLoadingPaymentSources]);

  if (isLoadingPaymentSources) return <Loader className="my-40" />;

  if (isAddingPaymentMethod)
    return (
      <AddPaymentMethod
        subscriptionId={subscriptionId}
        onNext={onNext}
        onBack={
          paymentSources.length ? () => setIsAddingPaymentMethod(false) : onBack
        }
      />
    );

  return (
    <PaymentMethodSelection
      subscriptionId={subscriptionId}
      paymentSources={paymentSources}
      selectedPaymentSource={paymentSource}
      addPaymentMethod={() => setIsAddingPaymentMethod(true)}
      onBack={onBack}
      onSelect={onSelect}
    />
  );
}
